export class LeadDays {

    constructor(public readonly value: number) {
        if (value < 0) {
            throw new Error('Lead days must be a positive number');
        }
    }

}
